import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, ROLES } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { apiGet, fetchAllPaginated, fetchSchoolsSimple } from '../services/api';
import { useEffectiveCity } from '../hooks/useEffectiveCity';
import RefreshButton from '../components/RefreshButton';
import AutocadastroPainel from '../components/usuarios/AutocadastroPainel';

/**
 * Usuários › Autocadastro: links por perfil, pedidos aguardando aprovação e
 * quem entrou por cada link.
 *
 * Era um painel que abria em cima da lista de Usuários e empurrava a tela.
 * Página própria, segue o município escolhido no menu (o administrador vê
 * os links e pedidos daquele município; sem escolha, os de todos).
 */
function AutocadastroLinks() {
  const { user } = useAuth();
  const { darkMode } = useTheme();
  const cidade = useEffectiveCity();
  const isAdmin = user?.role === ROLES.ADMIN;

  const [cidades, setCidades] = useState([]);
  const [escolas, setEscolas] = useState([]);
  const [roles, setRoles] = useState([]);
  const [aviso, setAviso] = useState(null);
  // Trocar a chave remonta o painel, que busca tudo de novo.
  const [versao, setVersao] = useState(0);

  useEffect(() => {
    Promise.all([
      fetchAllPaginated('/cities/'),
      fetchSchoolsSimple(),
      apiGet('/users/roles/'),
    ]).then(([c, e, r]) => {
      setCidades(c || []);
      setEscolas(e || []);
      setRoles(r || []);
    }).catch(() => {});
  }, []);

  return (
    <>
      <header className="flex flex-wrap gap-4 justify-between items-start mb-6 md:mb-8">
        <div>
          <Link to="/usuarios" className="text-sm text-[#0974BA] hover:underline">← Usuários</Link>
          <h1 className={`mt-1 text-2xl md:text-3xl font-medium bg-clip-text text-transparent ${darkMode
            ? 'bg-gradient-to-r from-gray-50 to-gray-400'
            : 'bg-gradient-to-r from-[#0974BA] to-[#2E4974]'
            }`}>
            Autocadastro
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Links para a equipe se cadastrar, os cadastros aguardando aprovação e quem entrou por cada link
            {cidade?.name
              ? <span className="text-sideb-blue"> - {cidade.name}</span>
              : isAdmin && <span> - todos os municípios</span>}
          </p>
        </div>
        <RefreshButton onClick={() => { setAviso(null); setVersao(v => v + 1); }} />
      </header>

      <AutocadastroPainel
        key={versao}
        darkMode={darkMode}
        isAdmin={isAdmin}
        cityId={isAdmin ? (cidade?.id || null) : null}
        cidades={cidades}
        escolas={escolas}
        roles={roles}
        aviso={aviso}
        setAviso={setAviso}
      />
    </>
  );
}

export default AutocadastroLinks;
